import { Button } from 'antd'
import styled, { css } from 'styled-components'
import { Row } from 'antd'
import { HomeBtnCss } from '@/common/styled'

export const ConnectWalletWrapper = styled.div`
  .wallet-connect-btn-web-profile {
    ${HomeBtnCss}
  }
  .wallet-connect-h5-div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .wallet-connect-btn,
  .wallet-connect-btn-home-web {
    min-width: 10.31rem;
    height: 3rem;
    color: ${(p) => p.theme.themeColor};
    font-family: 'NotoSansHans-Regular';
    font-style: normal;
    font-weight: 700;
    font-size: 0.88rem;
    line-height: 1.31rem;
    text-shadow: none !important;
    border: 0.06rem solid ${(props) => props.theme.themeColor};
    ${({ theme }) =>
      theme.mediaWidth.md(
        () => css`
          min-width: 12.19rem;
        `,
      )}
  }
  .wallet-connect-btn {
    border: none !important;
  }
  .wallet-connect-btn-home-web {
    background: transparent;
    border: 0.06rem solid ${(props) => props.theme.white};
    color: ${(props) => props.theme.white};
  }
  .wallet-connect-btn-h5 {
    min-width: 11rem;
    height: 2.81rem;
    background: linear-gradient(102.83deg, #ffa337 2.19%, #fab768 81.87%);
    border-radius: 0.25rem;
    font-family: 'NotoSansHans-Bold';
    font-weight: 700;
    font-size: 0.88rem;
    text-shadow: none !important;
    box-shadow: none;
    border: none;
  }
`

export const ModalTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  margin: 0.63rem 0;
`

export const AddressBtn = styled.div`
  position: relative;
  &:after {
    content: '';
    width: 100%;
    height: 3.13rem;
    position: absolute;
    bottom: 0;
    top: 3rem;
  }
  .address-logout {
    min-width: 6.5rem;
    height: 2.5rem;
    line-height: 2.5rem;
    position: absolute;
    bottom: -3rem;
    filter: drop-shadow(0rem 0.13rem 0.88rem rgba(0, 0, 0, 0.1));
    right: 0.94rem;
    background: ${(props) => props.theme.white};
    color: ${(props) => props.theme.black};
    font-family: 'NotoSansHans-Regular';
    font-style: normal;
    font-weight: 400;
    border: none;
    font-size: 0.88rem;
    z-index: 1;
    text-align: center;
    border-radius: 0.63rem;
    cursor: pointer;
    &::after {
      content: '';
      position: absolute;
      width: 0px;
      height: 0px;
      border-left: 0.75rem solid transparent;
      border-top: 0 solid transparent;
      border-right: 0.75rem solid transparent;
      border-bottom: 1rem solid ${(p) => p.theme.white};
      right: -4.16px;
      top: -0.5rem;
      z-index: -1;
      transform: rotate(-90deg);
    }
    &:hover {
      color: ${(p) => p.theme.themeColor};
    }
  }
`

export const AddressTitle = styled(Button)`
  height: 3rem;
  display: flex;
  align-items: center;
  padding: 0.25rem 0.94rem;
  background: ${({ theme }) => theme.white};
  span {
    line-height: 3rem;
    font-family: 'NotoSansHans-Regular';
    font-style: normal;
    font-weight: 700;
    font-size: 0.88rem;
    color: #d28a46;
  }
  &:hover,
  &:focus {
    background: ${({ theme }) => theme.white} !important;
  }
`

export const Leran = styled.div`
  font-family: 'NotoSansHans-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: 0.88rem;
  margin-bottom: 0.63rem;
  line-height: 1.31rem;
  color: ${(props) => props.theme.black};
  ${(props) =>
    props.theme.mediaWidth.md(
      () => css`
        margin-bottom: 0;
      `,
    )}
`

export const LeranLink = styled.a`
  color: #3396ff;
  font-family: 'NotoSansHans-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: 0.88rem;
  line-height: 1.31rem;
  &:hover {
    color: #3396ff;
  }
`

const btnCss = css`
  min-width: 5.38rem;
  min-height: 1.88rem;
  border-radius: 0.25rem;
  font-family: 'NotoSansHans-Regular';
  font-weight: 400;
  font-size: 0.88rem;
  color: ${(props) => props.theme.white};
`

export const AddressBtnH5 = styled(Row)`
  .address-btn-h5-left {
    display: flex;
    align-items: center;
    padding-left: 1rem;
    .text {
      font-family: 'NotoSansHans-Bold';
      font-weight: 700;
      font-size: 0.88rem;
      padding-left: 0.88rem;
    }
  }
  .address-btn-h5-right {
    display: flex;
    flex-direction: row-reverse;
    padding-right: 1.19rem;
    .right-details {
      ${btnCss}
      background: ${(props) => props.theme.themeColor};
      border: 0.06rem solid ${(props) => props.theme.themeColor};
    }
    .right-logout {
      ${btnCss}
      background: #C2C2C2;
      border: 0.06rem solid #c2c2c2;
    }
  }
`

export const AddressBtnWeb = styled(Button)`
  border-radius: 0.63rem;
  min-width: 9.81rem;
  min-height: 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #d28a46;
  background: ${({ theme }) => theme.white};
  border: none;
  .address-btn-web-left {
    display: flex;
    align-items: center;
    .text {
      font-family: 'NotoSansHans-Bold';
      font-weight: 700;
      font-size: 0.88rem;
      margin-left: 0.43rem;
    }
  }
  .address-btn-web-right {
    display: flex;
    flex-direction: row-reverse;
    margin-left: 0.63rem;
    .anticon {
      cursor: pointer;
    }
  }
  .address-row {
    display: flex;
    align-items: center;
  }
  &:hover {
    border: none;
    color: #d28a46;
    background: ${({ theme }) => theme.white};
  }
`
